import { IClientServiceMock } from "./client.types";

export const mockClientService = (): IClientServiceMock => ({
  getClients: jest.fn(),
  getClientDetail: jest.fn(),
  saveUpdateClient: jest.fn(),
  updateStatusClient: jest.fn(),
  postGenerateClientsReport: jest.fn(),
  syncClient: jest.fn(),
});
